// NPM imports.
import React, { useMemo } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

// Bounded context imports.
import routes from './routes'
import Instructions from './Instructions'
import Start from './Start'
import Chauffeur from './Chauffeur'
import Overview from './Overview'
import Uploads from './Uploads'
//import Damage from './Damage'
//import CloseUpUploads from './CloseUpUploads'
//import SigningDigital from './SigningDigital'
import Signing from './Signing'
//import TakeIn from './TakeIn'
import Questions from './Questions'
import End from './End'
import { useSelector } from 'react-redux'
import { useThemes } from '@domain/hooks'
import { companyNames, proccessType } from '@domain/constants'

function CheckIn() {
  const insurer = useSelector(state => state.insurer);

  const isThemed = !!insurer && insurer.brand !== companyNames.VIP && insurer.objectType !== proccessType.DI;
  const themes = useMemo(() => [isThemed ? 'theme-custom' : 'theme-def'], [isThemed]);
  useThemes(themes);

  return (
    <React.Fragment>
      <Routes>
        <Route path={routes.instructions} element={<Instructions />} />
        <Route path={routes.start} element={<Start />} />
        <Route path={routes.chauffeur} element={<Chauffeur />} />
        <Route path={routes.overview} element={<Overview />} />
        <Route path={`${routes.uploads}/*`} element={<Uploads />} />
        {/* <Route path={routes.damage} element={Damage} /> */}
        {/* <Route path={routes.closeUpUploads} element={CloseUpUploads} /> */}
        <Route path={routes.signing} element={<Signing />} />
        {/* <Route path={routes.signingDigital} element={SigningDigital} /> */}
        {/* <Route path={routes.takeIn} element={TakeIn} /> */}
        <Route path={routes.questions} element={<Questions />} />
        <Route path={routes.end} element={<End />} />
        <Route path='*' element={<Navigate to={routes.instructions} />} />
      </Routes>
    </React.Fragment>
  );
}

export default CheckIn
